
import { IGlobalMail } from "../Interfaces/IGlobalMail";
import { ISystemMail } from "../Interfaces/ISystemMail";
import {customFetcher} from "./customFetcher";
import {keepPreviousData, useMutation, useQuery} from "@tanstack/react-query";

export const useGetSystemMail = () => {
    const { data: systemMailArray, isLoading: isLoadingSystemMailArray, refetch: refetchSystemMailArray } = useQuery<ISystemMail[]>({
        refetchOnWindowFocus: false,
        queryKey: ['system_mail'],
        queryFn: () => customFetcher({ endpoint: '/system_mail/' }),
    });

    return { systemMailArray, isLoadingSystemMailArray, refetchSystemMailArray };
};

export const useUpdateSystemMail = () => {
    const { mutateAsync: updateSystemMail, isPending: isPendingSystemMail } = useMutation<ISystemMail, Error, ISystemMail>({
        mutationFn: (updateObject: ISystemMail) => {
            const formData = new FormData();
            formData.append('title', updateObject.title);
            formData.append('subject', updateObject.subject);
            formData.append('body', updateObject.body);

            (updateObject.new_attachments ?? []).forEach((file) => {
                formData.append('new_attachments', file);
            });

            if ((updateObject.delete_attachment_ids ?? []).length > 0) {
                formData.append('delete_attachment_ids', JSON.stringify(updateObject.delete_attachment_ids ?? []));
            }

            return customFetcher<ISystemMail>({
                endpoint: `/system_mail/${updateObject.id}/`,
                method: 'PUT',
                body: formData,
            });
        },
    });
    return { updateSystemMail, isPendingSystemMail };
};

export const useCreateGlobalMail = () => {
    const mutation = useMutation<any, Error, FormData>({
        mutationFn: async (formData: FormData) => {
            const res = await fetch('/api/global_mail/', {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            const data = await res.json();
            if (!res.ok) throw data;
            return data;
        },
    });

    return {
        createGlobalMail: mutation.mutateAsync,
        isPendingGlobalMail: mutation.isPending,
    };
};

export const GLOBAL_MAIL_PAGE_SIZE = 10;

export interface IGlobalMailPage {
    results: IGlobalMail[];
    count: number;
    next: string | null;
    previous: string | null;
}

export const useGetGlobalMail = (page: number) => {
    const { data, isLoading, refetch } = useQuery<IGlobalMailPage>({
        refetchOnWindowFocus: false,
        queryKey: ['global_mail', page],
        queryFn: () => customFetcher({ endpoint: `/global_mail/?page=${page}` }),
        placeholderData: keepPreviousData,   // vorherige Seite anzeigen, während die neue lädt
    });

    return {
        globalMails: data?.results ?? [],
        globalMailCount: data?.count ?? 0,
        isLoadingGlobalMailArray: isLoading,
        refetchGlobalMailArray: refetch,
        globalMailLoaded: data !== undefined,
    };
};
